module.exports = {
	"apiEndpoint": "https://bbyo-api-staging.herokuapp.com/api/v1",
	"publicEndpoint": "https://bbyo.hexatlanta.com/",
	"facebookAppId": "920258291402212",
	"stripePublishableKey": "pk_test_umtjH6YlxvIiDv0VKX5JB1vV",
	"amazonUrl": "https://bbyo-tmp-staging.s3.amazonaws.com/",
	"googleKey": "AIzaSyB0VgLqty-SkmfMeT33HVO_oLK0SNLOt_g",
	"isOnward": false
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/json-loader!./config-staging.json
 ** module id = 235
 ** module chunks = 1
 **/